import { GeneralInfoIndividualStudent, Status } from "@/models/stats.model";
import { StatsRest } from "@/services/rest/stats.rest";
import { GenericsUtils } from "@/utils/generics.util";
import { BehaviorSubject, Observable } from "rxjs";

export class GeneralService {
  private classroomId: string | undefined;

  constructor(
    private _stats = new StatsRest(),
    private _generics = new GenericsUtils()
  ) {
    this.classroomId = localStorage.getItem("stdClassroomId") ?? undefined;
  }

  private general$: BehaviorSubject<any> =
    new BehaviorSubject<GeneralInfoIndividualStudent>(
      new GeneralInfoIndividualStudent()
    );
  general: Observable<GeneralInfoIndividualStudent> =
    this.general$.asObservable();

  getStudentFromCourseById(courseId: string, studentId: string): void {
    this._stats
      .getStudentFromCourseById(courseId, studentId, {
        classroomId: this.classroomId,
      })
      .subscribe({
        next: (response) => {
          response.courseStudentStatus = this.remakeObjectStatus(
            response.courseStudentStatus
          );
          response.studentStatus = this.remakeObjectStatus(
            response.studentStatus
          );
          response.lastAccess = response.lastAccess
            ? this._generics.getDate(response.lastAccess)
            : "Não acessou";
          response.averageQuiz =
            response.averageQuiz == 0 ? " - " : String(response.averageQuiz);
          this.general$.next(response);
        },
      });
  }

  getStatus(status: string): string {
    if (status == Status.ACTIVE) {
      status = GenericsUtils.translateI18n(
        "stats.course.students.status.active"
      );
    } else if (status == Status.INACTIVE) {
      status = GenericsUtils.translateI18n(
        "stats.course.students.status.inactive"
      );
    } else if (status == Status.IN_PROGRESS) {
      status = GenericsUtils.translateI18n(
        "stats.course.students.status.inProgress"
      );
    } else if (status == Status.DONE) {
      status = GenericsUtils.translateI18n("stats.course.students.status.done");
    }
    return status;
  }

  getStatusColor(status: string): string {
    if (status == Status.INACTIVE) {
      status = "bg-h-error-100 text-h-error-800";
    } else if (status == Status.ACTIVE) {
      status = "bg-h-success-100 text-h-success-500";
    } else if (status == Status.IN_PROGRESS) {
      status = "bg-h-primary-100 text-h-primary-500";
    } else if (status == Status.DONE) {
      status = "bg-h-success-100 text-h-success-500";
    }
    return status;
  }

  remakeObjectStatus(item: any): any {
    var status = { name: "", class: "", value: "" };
    status.name = this.getStatus(item);
    status.class = this.getStatusColor(item);
    status.value = item;
    return status;
  }
}
